export default "<mat-slide-toggle [(ngModel)]=\"isApproved\" name=\"status\" (change)=\"invoke()\">\n</mat-slide-toggle>\n";